/**
 * @generated SignedSource<<395921d3b6d5df1359bfb1e69525039b>>
 * @relayHash 69cb5f9caba0c34421b46432dab7aab3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8abb8537c761c00bfeea5c6b03b1f395a0c5ed38f2ec729a915f7f365f5a2fe2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { srcVirtualAgentBrowseIntentsStatisticsQuery } from './srcVirtualAgentBrowseIntentsStatisticsQuery.graphql';

import newPerformancePage_provider from '@atlassian/jira-relay-provider/src/jsm-va-enable-performance-page.relayprovider';

const node: PreloadableConcreteRequest<srcVirtualAgentBrowseIntentsStatisticsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8abb8537c761c00bfeea5c6b03b1f395a0c5ed38f2ec729a915f7f365f5a2fe2",
    "metadata": {},
    "name": "srcVirtualAgentBrowseIntentsStatisticsQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjsmvaenableperformancepagerelayprovider": newPerformancePage_provider
    }
  }
};

export default node;
